export default {
  decentralizedNum: '终端分布所属区县数量'
}
